import { INavigationDotsData, INavigationDotsStyle } from "@pageBuilder/typings";
import { CssProperties } from "../../../models/css-property";
import { ElementStyleService } from "../../../services/element-style.service";

export class SliderNavigationDotsRenderer {

    constructor(private readonly styleService: ElementStyleService) {
    }

    public render(sectionElement: HTMLElement, navigationDotsData: INavigationDotsData): void {
        const sliderContent = sectionElement.querySelector(".slider-content");
        if (sliderContent) {
            const dotsWrapper = this.renderNavigationWrapperWithDots(sectionElement);
            sliderContent.append(dotsWrapper);
        }

        if (navigationDotsData.enable) {
            this.renderLinksStyles(sectionElement, navigationDotsData.style);
        } else {
            this.cleanup(sectionElement);
        }
    }

    private renderNavigationWrapperWithDots(slider: HTMLElement): HTMLElement {
        const dotsWrapper = this.ensureNavigationDotsWrapper(slider);
        const slides = slider.querySelectorAll<HTMLElement>(".slide");

        slides.forEach((slide, index) => {
            const dot = document.createElement("button");
            dot.dataset.number = slide.dataset.number;
            dot.classList.add("navigation-dot");
            dot.ariaLabel = `Slide ${index + 1}`;

            dotsWrapper.append(dot);
        });

        return dotsWrapper;
    }

    private renderLinksStyles(sectionElement: HTMLElement, data: INavigationDotsStyle): void {
        const dotsWrapperProps = new CssProperties();

        dotsWrapperProps.tryAdd("--dots-size", `${data.sizePx}px`);
        dotsWrapperProps.tryAdd("--dots-color", data.color);
        dotsWrapperProps.tryAdd("--dots-count", this.getCountDots(sectionElement).toString());
        dotsWrapperProps.tryAdd("--dots-wrapper-color", data.backgroundColor);

        dotsWrapperProps.tryAdd("background-color", data.backgroundColor);

        this.styleService.setStyle(sectionElement, `#${sectionElement.id} .navigation-dots-wrapper`, dotsWrapperProps.data);
    }

    private getCountDots(sectionElement: HTMLElement): number {
        return sectionElement.querySelectorAll(".navigation-dot").length ?? 1;
    }

    private cleanupLinksStyles(sectionElement: HTMLElement): void {
        this.styleService.clearStyle(sectionElement, `#${sectionElement.id} .navigation-dots-wrapper`);
    }

    public cleanup(sectionElement: HTMLElement): void {
        this.cleanupLinksStyles(sectionElement);

        this.removeNavigationDotsWrapper(sectionElement);
    }

    public getAllContentSelectors(sectionElement: HTMLElement): Array<string> {
        return [`#${sectionElement.id} .navigation-dots-wrapper`];
    }

    private ensureNavigationDotsWrapper(sectionElement: HTMLElement): HTMLElement {
        this.removeNavigationDotsWrapper(sectionElement);

        const dotsWrapper = document.createElement("div");
        dotsWrapper.classList.add("navigation-dots-wrapper");

        return dotsWrapper;
    }

    private removeNavigationDotsWrapper(sectionElement: HTMLElement): void {
        const wrapper = sectionElement.querySelector(".navigation-dots-wrapper");
        wrapper?.remove();
    }

}
